module.exports = __webpack_public_path__ + "static/media/item2.d396e097.png";